<template>
  <div>
    <div ref="chartContainer" style="width: 100%; height: 400px;" />
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'Echart',
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        color: ['#3398DB', '#00FA9A', '#6B8E23'],
        title: {
          text: ''
        },
        xAxis: {
          name: '类型',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        },
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
        ]
      }
      this.chart.setOption(this.option)
    },
    refresh(type, data, title) {
      this.option.title.text = title
      let keys = []
      switch (type) {
        case 1:
          keys = [
            { 'title': '投放新增', 'key': 'ad_reg' },
            { 'title': '用户邀请', 'key': 'invitation' },
            { 'title': '自然量', 'key': 'natural_quantity' }
          ]
          break

        case 2:
          keys = [
            { 'title': '投放费用', 'key': 'ad' },
            { 'title': '内购费用', 'key': 'pay_price' },
            { 'title': '广告变现', 'key': 'ad_price' }
          ]
          break

        case 3:
          keys = [
            { 'title': '付费率', 'key': 'pay_rate' },
            { 'title': '新增用户付费率', 'key': 'reg_pay_rate' }
          ]
          break

        case 4:
          keys = [
            { 'title': 'arppu', 'key': 'arppu' },
            { 'title': 'arpu', 'key': 'arpu' }
          ]
          break
      }

      for (const i in keys) {
        const val = keys[i]
        this.option.legend.data.push(val.title)
        this.option.xAxis.data = []
        const valArr = []
        for (const i in data) {
          const t = `第${data[i].week}周`
          this.option.xAxis.data.push(t)
          valArr.push(data[i][val.key])
        }
        const temp = {
          name: val.title,
          data: valArr,
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          }
        }
        this.option.series.push(temp)
      }
      this.chart.setOption(this.option, true)
    }
  }
}
</script>

<style scoped>

</style>
